/*

 Helper

 Load general helper functions

 */
let debug               = false;

const fs                = nw.require('fs');
//const path              = nw.require('path');
myApp.helper     = {}; //jshint ignore:line

// Main Entry Point
myApp.helper.init = function () {
    if (debug) console.log('Load Helpers!');

    nw.global.helper            = {};
    nw.global.helper.fileExists = myApp.helper.fileExists;
};


myApp.helper.fileExists = function ( pFile ) {
    if (debug) console.log('Check if file exists:', pFile);

    if( fs.existsSync( pFile ) )
        return true;
    else
        return false;
};
